export const SYNCHRONIZED_ATTACHMENT = 'synchronizedAttachment';
export const SYNCHRONIZED_PICTURE = 'synchronizedPicture';

// export const isAndroid = () => window.cordova && window.cordova.platformId === 'android';
// export const isIOS = () => window.cordova && window.cordova.platformId === 'ios';
